import script from "./FloatMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatMenu.vue?vue&type=script&setup=true&lang=js"

import "./FloatMenu.vue?vue&type=style&index=0&id=07d56520&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d56520"]])

export default __exports__